<template>
  <div id="app" class="text-gray-800">
    <ais-instant-search
        :index-name="index"
        :search-client="searchClient"
        :search-function="searchFunction"
    >
      <!--
      Enable this to enable filtering
      <ais-configure
          :filters="filters"
      /> -->

      <toolbar></toolbar>

      <div class="pt-16 sm:pt-16  md:pt-20 absolute top-0 right-0 bottom-0 left-0 flex">

        <div class="hidden sm:flex items-stretch overflow-scroll lg:block w-4/12 md:w-3/12 xl:w-1/5 bg-gray-200"
             v-on:click="searching">
          <Categories/>
        </div>

        <router-view class="flex-1" :key="$route.fullPath">
        </router-view>

        <Cart/>
      </div>
    </ais-instant-search>

  </div>
</template>

<script>
import Home from './pages/home'
import Toolbar from './components/Toolbar'
import Categories from './components/Categories'
import algoliasearch from 'algoliasearch/lite'
import Cart from './components/Cart'

// import 'instantsearch.css/themes/algolia-min.css';

const algoliaClient = algoliasearch(
    appData.algoliaAppKey,
    appData.algoliaSearchKey
);

const searchClient = {
  search(requests) {
    const newRequests = requests.map((request) => {
      // test for empty string and change request parameter: analytics
      if (!request.params.query || request.params.query.length === 0) {
        request.params.analytics = false
      }
      return request
    });
    return algoliaClient.search(newRequests);
  },
};

export default {
  name: "app",
  components: {
    Home,
    Toolbar,
    Categories,
    Cart
  },
  data() {
    return {
      searchClient,
      searchFunction(helper) {
        // if (router.currentRoute.name == 'product') {
        //     helper.addHierarchicalFacetRefinement('categories.level1', '17. Tableware & Galley Utensils')
        // }
        helper.search();
      },
      index: appData.algoliaIndex,
      filters: "categories.level1: '33. Safety Equipment'"
    };
  },
  methods: {
    searching: function(event) {
      if (this.$route.name != 'browse') {
        this.$router.push({name: 'browse'})
      }
    },
  },
  mounted() {
    this.$store.commit('user/setGroups', appData.user.groups.split(','));
    this.$store.commit('user/setId', appData.user.id);
    this.$store.commit('user/setEmail', appData.user.email);
    this.$store.commit('user/setFirstName', appData.user.firstName);
    this.$store.commit('user/setLastName', appData.user.lastName);
    if (appData.user.isAdmin == '1') {
      this.$store.commit('user/setAdmin');
    }
    if (appData.user.ihm == '1') {
      this.$store.commit('user/setIhm');
    }
  }
}
</script>